// eslint-disable-next-line no-restricted-imports -- legacy, use @clipboard-health/date-time. See https://www.notion.so/BP-Date-Time-2ef8643321f48032ad80e8a5b30aa278 for more information
import { format, parseISO } from "date-fns";

import { type ChatChannel } from "../types";
import { getChatStatus } from "./getChatStatus";

export function getChannelShiftTime(channel?: ChatChannel): string {
  if (!channel) {
    return "Loading...";
  }

  if (!channel.shift) {
    return "No upcoming shifts";
  }

  const status = getChatStatus(channel);
  if (["nothing", "past"].includes(status)) {
    return "No upcoming shifts";
  }

  const start = parseISO(channel.shift.start);
  const end = parseISO(channel.shift.end);

  const until = `until ${format(end, "h:mm a")}`;
  const at = `at ${format(start, "h:mm a")}`;

  if (status === "in progress") {
    return `Shift in progress ${until}`;
  }

  let date = "";
  if (status === "today") {
    date = `today ${at}`;
  }

  if (status === "tomorrow") {
    date = `tomorrow, ${format(start, "MMM dd")} ${at}`;
  }

  if (status === "ahead") {
    date = `on ${format(start, "EEEE, MMM dd")} ${at}`;
  }

  return `Next shift ${date}`;
}
